const baseUrl = {
    baseUrl: 'https://api.brynexapparels.in/'
}
export default baseUrl


// https://api.brynexapparels.in/

// https://unicodenew-9i0k.onrender.com/